export default __webpack_public_path__ + "static/media/reset-password.2f104447.png";